"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnchorP2PFieldView = exports.AnchorManualFieldView = void 0;
exports.viewAnchorManualEdit = viewAnchorManualEdit;
var tslib_1 = require("tslib");
var core_shared_1 = require("@ikegps/core-shared");
var lodash_1 = require("lodash");
var anchor_input_1 = require("../../../components/input/anchor.input");
var anchor_input_state_1 = require("../../../components/input/anchor.input.state");
var i18n_1 = require("../../../i18n");
var field_info_1 = require("../../field.info/field.info");
var point_collection_cache_1 = require("../../topological.editor.map/point.collection.cache");
function viewAnchorManualEdit(field, ctrl) {
    var inputState = ctrl.changeState.getState(field.id);
    // convert GPS to vector
    var source = point_collection_cache_1.TopologicalPointCollectionCache.getCollectionLocation(field.collection.revision);
    var distanceBearingPitch = field.distanceBearingPitch(source);
    if (!inputState) {
        var value = field.value;
        inputState = new anchor_input_state_1.AnchorInputState(field);
        inputState.onValue(function () {
            field.Mutator.manual(inputState.value);
            // This will ensure topo map is updated (if it exists) and a user is updating vector locations
            point_collection_cache_1.TopologicalPointCollectionCache.dropCollectionVectors(field.collection.revision);
        });
        ctrl.changeState.addState(field.id, inputState);
        if (value != null) {
            inputState.setValue({
                distance: distanceBearingPitch.distance,
                bearing: distanceBearingPitch.bearing,
                pitch: distanceBearingPitch.pitch,
                placement: value.placement,
                relatedSpanIds: value.relatedSpanIds,
                collectionTool: 'VECTOR'
            });
        }
    }
    var linkableSpanFields = [];
    field.collection.forEachField(function (x) {
        if (core_shared_1.CollectionModelFieldVector.isVectorField(x)) {
            linkableSpanFields.push(x);
        }
    });
    if (!(0, lodash_1.isEqual)(linkableSpanFields.sort(function (a, b) { return a - b; }), inputState.cachedSpanFields)) {
        inputState.populateRelatedSpansOptions(linkableSpanFields);
    }
    // If none of the inputs are focused, and the field model value changes
    // the input state should also update.
    if (distanceBearingPitch !== null && !(inputState.distance.meters.focused ||
        inputState.distance.inch.focused ||
        inputState.distance.feet.focused ||
        inputState.bearing.focused)) {
        inputState.setValue(tslib_1.__assign(tslib_1.__assign({}, distanceBearingPitch), { placement: inputState.placement.value, relatedSpanIds: inputState.relatedSpans.map(function (x) { return x.value; }), collectionTool: 'VECTOR' }));
    }
    return anchor_input_1.AnchorInput.view(inputState, ctrl, field);
}
exports.AnchorManualFieldView = {
    hasClear: function () {
        return false;
    },
    viewInline: function (field) {
        if (!field.hasValue()) {
            return null;
        }
        // convert location to distance/bearing
        var source = point_collection_cache_1.TopologicalPointCollectionCache.getCollectionLocation(field.collection.revision);
        var distanceBearingPitch = field.distanceBearingPitch(source);
        return "".concat(field_info_1.FieldInfo.viewVectorInline(distanceBearingPitch), ", Alignment: ").concat((0, i18n_1.Translate)(field.value.placement));
    },
    hasDetail: function () {
        return false;
    },
    viewDetail: function () {
        return null;
    },
    viewEdit: function (field, ctrl) {
        return viewAnchorManualEdit(field, ctrl);
    }
};
exports.AnchorP2PFieldView = {
    viewInline: function (field) {
        // convert location to distance/bearing
        var source = point_collection_cache_1.TopologicalPointCollectionCache.getCollectionLocation(field.collection.revision);
        var distanceBearingPitch = field.distanceBearingPitch(source);
        return "".concat(field_info_1.FieldInfo.viewVectorInline(distanceBearingPitch), ", Alignment: ").concat((0, i18n_1.Translate)(field.value.placement));
    },
    hasDetail: function () {
        return true;
    },
    viewDetail: function (field) {
        var collection = field.collection;
        var captures = field.getCaptures();
        var p2pMeasurement = core_shared_1.MultiPoint.Points(captures);
        var stats = [
            { name: i18n_1.T.DISTANCE_VERTICAL, value: Math.abs(p2pMeasurement.vertical) },
            { name: i18n_1.T.DISTANCE_HORIZONTAL, value: p2pMeasurement.horizontal }
        ];
        return field_info_1.FieldInfo.viewCaptures(collection, captures, stats);
    },
    viewEdit: function (field, ctrl) {
        return viewAnchorManualEdit(field, ctrl);
    }
};
//# sourceMappingURL=anchor.field.view.js.map